import { render } from "./ClientOwnerCard.vue?vue&type=template&id=36cd65af"
import script from "./ClientOwnerCard.vue?vue&type=script&lang=js"
export * from "./ClientOwnerCard.vue?vue&type=script&lang=js"

import exportComponent from "/Users/onisiforosgeorgiou/WebstormProjects/AgencyNow/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__